// import routerView from "@/components/otherTpl/routerView";
// 首页
export default [
    {
        path: '/index',
        name: 'DsHome',
        component: () => import('@/views/home/index'),
        meta: {
            title: '首页',
            icon: 'menu_home',
            keepAlive: true,
            modules: [1000]
        }
    }
];
